export const STORAGE_KEY_MOCK = 'zkex_v3_mock'
export const STORAGE_VALUE_MOCK = '1'
